"use strict";

var ACC;
var callCustomerData = true;
ACC.gtm = {
  gtmGlobal: {},
  pageName: '',
  pageType: '',
  pageUrl: '',
  pageFromBfCache: false,
  storeBanner: {
    20: 'tkmaxx',
    21: 'homesense'
  },
  resize: false,
  eventPushDelay: 0,
  _autoload: [
    "attachProductClickHandler",
    "bindPromotionClickEvents",
    "checkProductInLoveList"
  ],
  components: [],
  productImpressions: [],
  /***
   * Since the implementation of ACC.gtm is split across two modules
   * (one for critical GTM functions and one for the "rest"), this method
   * acts as a polyfill and checks if the function being called is available on the ACC.gtm object.
   * If it isn't, then the function waits for the "acc.gtm.loaded" event which is triggered when all of
   * ACC.gtm is loaded (even the non-critical ones)
   * @param func  The function name that is to be called
   * @param arguments Any arguments to be passed to `func`
   */
  callWhenLoaded: function (func) {
    /**
     * Calls `func` with the `args` provided
     * @param func  The name of the function
     * @param args  The arguments to be passed to the function
     */
    function call(func, args) {
      var fn = ACC.gtm[func];
      fn.apply(null, args);
    }

    // If there were any arguments supposed to be passed to `func`, copy them to the `args` array
    // Note that we start at index 1 because index 0 is `func` (the function name that is to be called)
    var args = [];
    for (var i = 1; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    if (typeof (ACC.gtm[func]) === "function") {
      // The function already exists on the ACC.gtm object
      call(func, args);
    } else {
      // Function doesn't exist yet on the ACC.gtm object
      // Event "acc.gtm.loaded" will be triggered when everything GTM-related is loaded
      document.addEventListener("acc.gtm.loaded", function () {
        call(func, args);
      });
    }
  },
  eventsQueue: function () {
    // a map of name and number of invocations of that event that are waiting to be pushed
    var queue = {};

    return {
      add: function (eventName) {
        eventName = eventName || '';
        if ('undefined' == typeof queue[eventName]) {
          queue[eventName] = 1;
        } else {
          queue[eventName]++;
        }
      },
      remove: function (eventName) {
        eventName = eventName || '';
        if ('undefined' != typeof queue[eventName]) {
          queue[eventName]--;
          if (0 === queue[eventName]) {
            delete queue[eventName];
          }
        }
      },
      getQueuePosition: function (eventName) {
        eventName = eventName || '';
        if ('undefined' != typeof queue[eventName]) {
          return queue[eventName];
        }

        return 0;
      }
    }
  }(),  // IIFE

  getGtmScreenSize: function () {
    if (window.matchMedia('(max-width: 640px)').matches) {
      return 'xsmall';
    } else if (window.matchMedia('(max-width: 768px)').matches) {
      return 'small';
    } else if (window.matchMedia('(max-width: 979px)').matches) {
      return 'medium';
    }
    // Same as '(min-width: 980px)'
    return 'large';
  },

  pushGlobalGtmContainer: function (data, callbackUrl, callbackForm) {
    var skipGtmUpdates = ACC.gtmToGa && ACC.gtmToGa.verifySkipGtmTreatments(data);
    var gtmGlobalContainer = data || {};

    if (!skipGtmUpdates) {
      // Update customer details to global data
      var gtmGlobalEcommerce = gtmGlobalContainer['ecommerce'];
      var ecomProps = ['detail', 'add', 'click', 'remove', 'checkout', 'purchase'];
      var searchTerm = localStorage.getItem('searchTerm');
      var searchCategorySuggestion = localStorage.getItem('searchCategorySuggestion');
      var presentationItemPosition = window.localStorage.getItem("ITEM_POSITION_TRACK_KEY");

      ecomProps.forEach(function (prop) {
        if (gtmGlobalEcommerce && gtmGlobalEcommerce[prop] && gtmGlobalEcommerce[prop]['products']) {
          gtmGlobalEcommerce[prop]['products'].forEach(function (ecommerceTag) {
            // The search term is supposed to be stored on product-dimension level with this key: "dimension82"
            // The search suggestion is supposed to be saved on a product-dimension level with key: dimension83
            if (ecommerceTag) {
              ecommerceTag['dimension82'] = searchTerm;
              ecommerceTag['dimension83'] = searchCategorySuggestion;
            }
          });

          // if there are no items in local storage, position will be null by default
          if (prop === 'add' && presentationItemPosition !== null) {
            var parsedList = JSON.parse(presentationItemPosition);
            /* - Products from a carousel, which are shown on PDP, cart page, include a position already.
                - Products added through quickbuy on search, pdp, lovelist, include a position.
                - The product shown on pdp does not include position so grab it from session storage. That is stored
                when the user clicks on a product from PLP, search, lovelist.
            */
            data["ecommerce"]["add"]['products'].forEach(function (product) {
              if (!product['position']) {
                var positionData = parsedList.filter(function (el) {
                  return product?.id?.includes(el.id);
                }).slice(-1)[0];
                product['position'] = positionData ? positionData.position : 'null';
              }
            });
          }

          // if there are no items in local storage, position will be null by default
          if (prop === 'purchase' && presentationItemPosition !== null) {
            var parsedPositions = JSON.parse(presentationItemPosition);
            // prooducts are reported in purchase->ecomm->products. initially they all have position null
            data["ecommerce"]["purchase"]['products'].forEach(function (product) {
              if (!product['position']) {
                var positionItem = parsedPositions.filter(function (el) {
                  return product.id.includes(el.id);
                }).slice(-1)[0];
                product['position'] = positionItem ? positionItem.position : 'null';
              }
            });
          }

          //remove the search term from local storage once the order is confirmed
          if (prop === 'purchase') {
            localStorage.removeItem('searchTerm');
            localStorage.removeItem(window.ACC.quickBuyListKey);
            window.localStorage.removeItem("ITEM_POSITION_TRACK_KEY");
          }
        }
      });

      if (gtmGlobalEcommerce && gtmGlobalEcommerce['impressions']) {
        gtmGlobalEcommerce['impressions'].forEach(function (ecommerceTag) {
          // The search term is supposed to be stored on product-dimension level with this key: "dimension82"
          // The search suggestion is supposed to be saved on a product-dimension level with key: dimension83
          ecommerceTag['dimension82'] = searchTerm;
          ecommerceTag['dimension83'] = searchCategorySuggestion;
        });
      }

      if (gtmGlobalEcommerce && gtmGlobalEcommerce['products']) {
        gtmGlobalEcommerce['products'].forEach(function (ecommerceTag) {
          // The search term is supposed to be stored on product-dimension level with this key: "dimension82"
          // The search suggestion is supposed to be saved on a product-dimension level with key: dimension83
          ecommerceTag['dimension82'] = searchTerm;
          ecommerceTag['dimension83'] = searchCategorySuggestion;
        });
      }

      var event = gtmGlobalContainer['event'];
      if (event === 'detail') {
        var isSelectedFromQB = 'No';
        if (gtmGlobalEcommerce && gtmGlobalEcommerce['detail']) {
          // if length > 1 it should mean this is a bundle
          var productsArray = gtmGlobalEcommerce['detail']['products'] || [];

          var itemPosition = "null";
          if (presentationItemPosition) {
            var positionsList = JSON.parse(presentationItemPosition);
            // if productsArray is a bundle and there is tracking data, grab the last entry by bundleId
            if (productsArray.length === 1) {
              var item = positionsList.filter(function (el) {
                return productsArray[0]['id'] === el.id;
              }).slice(-1)[0];

              // if there is no item found with the product id, add position null
              itemPosition = item ? item.position : "null";
            } else {
              // it should mean here we have a bundle
              // make sure that there is a product for at least 1 of the product ids
              var foundsItems = [];
              productsArray.forEach(function (el) {
                var i = positionsList.filter(function (e) {
                  return el.id === e.id;
                });
                foundsItems = foundsItems.concat(i);
              });
              // i found at least 1 product
              if (foundsItems.length > 0) {
                var foundPositionItem = positionsList.filter(function (el) {
                  return foundsItems[0].bundleId === el.bundleId
                }).slice(-1)[0];

                itemPosition = foundPositionItem ? foundPositionItem.position : "null";
              } else {
                itemPosition = "null";
              }
            }
          }

          productsArray.forEach(function (product) {
            if (window.localStorage.getItem(window.ACC.selectedFromQB)) {
              var selectedProductId = window.localStorage.getItem(window.ACC.selectedFromQB);
              if (product.id === selectedProductId) {
                isSelectedFromQB = 'Yes';
              }
            }
            product['dimension95'] = isSelectedFromQB;
            // need to populate the position for each item in a bundle
            product['position'] = itemPosition;
          });
        }
        window.localStorage.removeItem(window.ACC.selectedFromQB);
      }

      // Only add to cart / remove from cart calls get the latest customer and basket data in the response from the server
      // So we need to decide based on the event if we want to save customer and basket data or fetch from the global object
      if (event === 'addToCart' || event === 'removeFromCart' || event === 'checkout' || event === 'addToLoveList' || event === 'removeFromLoveList') {
        // These calls have the latest customer and basket data from the customer
        // so update ACC.gtm.gtmGlobal object with that data
        ACC.gtm.saveGtmCustomerDetails(gtmGlobalContainer);
      } else {
        // No customer and basket data as part of the server response for these calls, so
        // fetch customer and basket data from the global object ACC.gtm.gtmGlobal
        gtmGlobalContainer = ACC.gtm.populateGtmCustomerDetails(gtmGlobalContainer);
      }

      // Update the screen size
      gtmGlobalContainer['screenSize'] = ACC.gtm.getGtmScreenSize();

      // initialize global variables so that it will be used on click ajax calls or gtmNavigationEventCallback
      ACC.gtm.pageName = encodeURIComponent(gtmGlobalContainer['pageName']);
      ACC.gtm.pageType = encodeURIComponent(gtmGlobalContainer['pageType']);
      ACC.gtm.pageUrl = encodeURI(gtmGlobalContainer['pageUrl']);
    }

    /**
     * If the 'submitGtmEventData' function was passed a returnUrl it will have
     * been stored as the value of ACC.gtm.callBackUrl. In this case, we add an eventCallback
     * and eventTimeout to the data object we push to GTM to ensure tracking data is pushed ahead of page unload
     *
     * Actions ticket: TJXUAT-1533 – "Google Analytics tags on Mac Safari are not firing before
     * the page unloads on click of a product from the PLP"
     */
    if (callbackUrl || callbackForm) {
      if (window.hasOwnProperty('google_tag_manager')) {
        gtmGlobalContainer.eventTimeout = 2000;
        gtmGlobalContainer.eventCallback = function (containerId) {
          if (containerId.startsWith("GTM-")) {
            ACC.gtm.gtmNavigationEventCallback(callbackUrl, callbackForm);
          }
        };
      }
      else {
        ACC.gtm.gtmNavigationEventCallback(callbackUrl, callbackForm);
      }
    }

    if (skipGtmUpdates) {
      ACC.gtmToGa.pushGaGlobalContainer(gtmGlobalContainer);
      return gtmGlobalContainer;
    }

    // Final data push to gtm
    if (typeof (dataLayer) != 'undefined') {
      dataLayer.push(gtmGlobalContainer);
    }
    if (ACC.gtmToGa) {
      ACC.gtmToGa.convertAndPushGlobalContainer(gtmGlobalContainer);
    }
    return gtmGlobalContainer;
  },

  gtmNavigationEventCallback: function (callbackUrl, callbackForm) {
    if (callbackUrl && callbackUrl !== window.location.href) {
      if (!ACC.gtm.pageFromBfCache) {
        window.location = callbackUrl;
      }
    } else if (callbackForm !== undefined && callbackForm.length > 0) {
      if ($("#" + callbackForm).length > 0 || $('form[name=' + callbackForm + ']').length > 0) {
        if ($("#" + callbackForm)[0].name === 'deliveryMethodForm') {
          var selectedDeliveryAddress = $("input[name='deliveryAddress']:checked").val();
          $("#addressId").val(selectedDeliveryAddress);
          $('#deliveryMethodSubmit').prop('disabled', true);
        }

        $("#" + callbackForm).submit();
      }
    }
  },

  gtmEventNameFromData: function (jsonArr) {
    if (jsonArr !== undefined && jsonArr != null) {
      return jsonArr['event'];
    }
    return null;
  },

  gtmPushOrDelayEventData: function (data, componentId, callback, storageTag = 'gtm', skipLSSave = false) {
    //In live we are seeing this data comes as empty for some components, it may be due to akamai cache
    if (data !== null && data !== undefined) {
      var eventName = ACC.gtm.gtmEventNameFromData(data) || '';
      var delay = ACC.gtm.eventsQueue.getQueuePosition(eventName) * ACC.gtm.eventPushDelay;
      // Add this to a queue, if a similar event comes around it will wait
      // GTM collects only the latest event if two similar events are fired in quick succession
      ACC.gtm.eventsQueue.add(eventName);
      window.setTimeout(ACC.gtm.gtmDelayEventCallback, delay, data, eventName);
      //Store it in local storage for later onclick usage
      if (!skipLSSave && componentId !== null && componentId !== undefined) {
        //prefixing the variable name with gtm for better understanding/maintenance of variables
        var storageName = storageTag + '.' + componentId;
        localStorage.setItem(storageName, JSON.stringify(data));
      }

      if (typeof callback === "function") {
        callback(data);
      }
    }
  },

  /**
   * Collects product impressions in a JS variable so that associated
   * information can be used later in tracking event handlers
   *
   * The product objects should at least be of the following shape:
   * {
   *     "id": "<PRODUCT_ID>",
   *     "list": "<LIST_NAME>"
   * }
   */
  collectProductImpressions: function (gtmData) {
    var products = [];
    try {
      // We need a deep clone
      products = JSON.stringify(gtmData.ecommerce.impressions.filter(function (product) {
        // Drop any products that do not have "id" and "list" attributes
        return product['id'] && product['list']
      }));
    } catch (error) {
      console.warn("No products found");
    } finally {
      var productImpressions = ACC.gtm.productImpressions;
      ACC.gtm.productImpressions = productImpressions.concat.apply(ACC.gtm.productImpressions, JSON.parse(products));
    }
  },

  gtmDelayEventCallback: function (data, eventName) {
    ACC.gtm.pushGlobalGtmContainer(data);
    ACC.gtm.eventsQueue.remove(eventName);
  },

  submitGtmEventData: function (options, returnUrl, returnForm) {
    // fetch GTM tracking date from the server
    var callbackUrl = '';
    var callbackForm = '';

    // set either url or form only
    if (returnUrl !== undefined && returnUrl.length > 0) {
      callbackUrl = location.protocol + "//" + location.host + returnUrl;
    } else {
      callbackForm = returnForm;
    }

    $.ajax({
      url: ACC.config.encodedContextPath + '/gtm/getGtmEventData',
      data: options,
      async: false,
      dataType: "html"
    }).done(function (data) {
      if (data !== undefined) {
        ACC.gtm.pushGlobalGtmContainer(jQuery.parseJSON(data), callbackUrl, callbackForm);
      } else {
        ACC.gtm.gtmNavigationEventCallback(callbackUrl, callbackForm);
      }
    });
  },
  isEmpty: function (obj) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    }
    return false;
  },
  updateGtmGlobalData: function (gtmGlobalObj) {
    if (gtmGlobalObj.ecommerce && gtmGlobalObj.ecommerce.purchase && gtmGlobalObj.ecommerce.purchase.products) {
      var productsArray = gtmGlobalObj.ecommerce.purchase.products;
      for (var i = 0; i < productsArray.length; i++) {
        var productId = productsArray[i].id;
        var productLovedStatus = ACC.lovelistStatusNo;
        if (ACC.gtm.checkProductInLoveList(productId.toString())) {
          productLovedStatus = ACC.lovelistStatusYes;
        }

        var isAddedFromQB = 'No';
        if (ACC.gtm.checkProductFromQuickBuy(productsArray[i].dimension4)) {
          isAddedFromQB = 'Yes';
        }
        gtmGlobalObj.ecommerce.purchase.products[i].dimension95 = isAddedFromQB;
        gtmGlobalObj.ecommerce.purchase.products[i].dimension85 = productLovedStatus;
      }
    }
    return gtmGlobalObj;
  },

  checkProductInLoveList: function (product, bundleIds) {
    var productCode = product;
    var inLocalStorage = false;

    if (!ACC.gtm.isEmpty(productCode)) {
      var loveListKey = ACC.lovelistKey;
      var currentLoveList = ACC.gtm.getLocalStorageParsedItem(loveListKey);
      if (Array.isArray(currentLoveList?.loveListProductInfo)) {
        var currentProductItems = currentLoveList.loveListProductInfo;
        inLocalStorage = ACC.gtm.checkEntryInLS(currentProductItems, productCode, bundleIds);
      }
    }
    return inLocalStorage;
  },

  getLocalStorageParsedItem: function (key) {
    var parsedData = null;
    if (key && localStorage.getItem(key)) {
      try {
        parsedData = JSON.parse(localStorage.getItem(key));
      }
      catch {
        localStorage.removeItem(key);
        console.error(`Error parsing ${key} data from localStorage, removing corrupted data.`);
      }
    }
    return parsedData;
  },

  checkEntryInLS: function (currentProductItems, productCode, bundleIds) {
    var setLoved = false;
    var checkType = !ACC.gtm.isEmpty(bundleIds) ? "bundleId" : "productCode";
    $.each(currentProductItems, function (key, value) {
      var lsProductCode = value.productCode.toString();
      if ((checkType == "bundleId") && (value.bundleId.toString() === bundleIds.toString())) {
        setLoved = true;
        return false;
      }
      if ((checkType == "productCode") && (lsProductCode === productCode.toString())) {
        setLoved = true;
        return false;
      }
    });
    return setLoved;
  },

  getBundleId: function () {
    var bundleId = '';
    if (ACC.gtm.pageType === 'ProductPage' || ACC.gtm.pageType === 'FlashProductPage') {
      bundleId = $('.pdp-add-lovelist-section').attr('data-product-bundleid');
    }
    return bundleId;
  },

  checkProductFromQuickBuy: function (productID) {
    var productCode = productID;
    var isInLocalStorage = false;

    if (!ACC.gtm.isEmpty(productCode)) {
      var quickbuyListKey = ACC.quickBuyListKey;

      if (window.localStorage.getItem(quickbuyListKey)) {
        var quickBuyList = JSON.parse(window.localStorage.getItem(quickbuyListKey) || '[]');
        isInLocalStorage = ACC.gtm.checkProductInQBList(quickBuyList, productCode);
      }
      return isInLocalStorage;
    }
  },

  checkProductInQBList: function (quickBuyList, productCode) {
    var productInQBList = false;

    $.each(quickBuyList, function (key, value) {
      if (value == productCode) {
        productInQBList = true;
        return false;
      }
    });
    return productInQBList;
  },

  removeFromQuickBuyLS: function (productID) {
    var productCode = productID;
    var quickBuyKey = ACC.quickBuyListKey;

    if (!ACC.gtm.isEmpty(productCode)) {
      var quickbuyListKey = ACC.quickBuyListKey;

      if (window.localStorage.getItem(quickbuyListKey)) {
        var quickBuyList = JSON.parse(window.localStorage.getItem(quickbuyListKey) || '[]');

        quickBuyList = $.grep(quickBuyList, function (val) {
          return val != productCode;
        });
        window.localStorage.setItem(quickBuyKey, JSON.stringify(quickBuyList));
      }
    }
  },

  /**
   * Updates the passed in object with values from ACC.gtm.gtmGlobal object
   *
   * @param data  The object to be updated
   * @returns {*}
   */
  populateGtmCustomerDetails: function (data) {
    var gtmGlobal = ACC.gtm.gtmGlobal || {};
    data = data || {};

    // update customer details
    data['customerType'] = gtmGlobal['customerType'];
    data['customerGender'] = gtmGlobal['customerGender'];
    data['loginStatus'] = gtmGlobal['loginStatus'];
    data['customerId'] = gtmGlobal['customerId'];
    data['loyaltyCustomer'] = gtmGlobal['loyaltyCustomer'];
    data['hasTransacted'] = gtmGlobal['hasTransacted'];

    // if email address or phone number are empty, set them to null
    // needed for CAPI implementation
    data['email_address'] = gtmGlobal['email_address'] || null;
    data['phone_number'] = gtmGlobal['phone_number'] || null;

    // dont add basket for order confirmation, dont override for add/remove cart & checkout pages where the basket totals updated
    var skip_events = ['purchase', 'checkout_option', 'checkout', 'wpLoad', 'apple_payment_error'];
    if (skip_events.indexOf(data['event']) < 0) {
      data['basket'] = gtmGlobal['basket'];
    }
    // populate lovelistStatus on lineItems
    if (window.ACC.isLoveListEnabled === 'true' && !ACC.gtm.isEmpty(data['basket']) && data['basket'].lineItems && data['basket'].lineItems.length > 0) {
      data['basket'].lineItems.forEach(function (lineItem, index) {
        var productCode = lineItem.id;
        var productLovedStatus = ACC.lovelistStatusNo;
        var bundleId = ACC.gtm.getBundleId();
        if (ACC.gtm.checkProductInLoveList(productCode, bundleId)) {
          productLovedStatus = ACC.lovelistStatusYes;
        }
        data['basket'].lineItems[index].dimension85 = productLovedStatus;
      });
    }

    if (data['event'] === "NwsLtrSubs") {
      data['basket'] = null;
    }
    return data;
  },

  /***
   * Updates customer details in the ACC.gtm.gtmGlobal object
   * @param data
   */
  saveGtmCustomerDetails: function (data) {
    data = (typeof (data) === "string") ? JSON.parse(data) : data;
    data = data || {};
    // update customer details in global variables
    ACC.gtm.gtmGlobal['customerType'] = data['customerType'];
    ACC.gtm.gtmGlobal['customerGender'] = data['customerGender'];
    ACC.gtm.gtmGlobal['loginStatus'] = data['loginStatus'];
    ACC.gtm.gtmGlobal['customerId'] = data['customerId'];
    ACC.gtm.gtmGlobal['loyaltyCustomer'] = data['loyaltyCustomer'];
    ACC.gtm.gtmGlobal['hasTransacted'] = data['hasTransacted'];
    ACC.gtm.gtmGlobal['basket'] = data['basket'];

    ACC.gtm.gtmGlobal['email_address'] = data['email_address'] || null;
    ACC.gtm.gtmGlobal['phone_number'] = data['phone_number'] || null;
    ACC.gtm.getItemPositionData(ACC.gtm.gtmGlobal, false);
    localStorage.setItem("gtm.global", JSON.stringify(ACC.gtm.gtmGlobal));
  },

  /*
    - it is supposed to receive gtmCustomerData when a backend call is done to addToCart
    - data will come as a json string
    - it will also contain the basket data of the customer
    - return the new gtmCustomerData with modified positions if it was the case
    - if there is no position tracking available, just return the existing gtmCustomerData
  */
  getItemPositionData: function (data, isJson) {
    var parsedData = isJson === true ? JSON.parse(data) : data;
    var basket = parsedData['basket'];
    var positionData = window.localStorage.getItem("ITEM_POSITION_TRACK_KEY");
    if (basket && basket['lineItems'].length > 0 && positionData) {
      var parsedPosition = JSON.parse(positionData);
      basket['lineItems'].forEach(function (b) {
        var itemID = b['id'];
        var foundPos = parsedPosition.filter(function (el) {
          return itemID.includes(el.id)
        }).slice(-1);
        b['position'] = foundPos.length > 0 ? foundPos[0]['position'] : 'null';
      });
    }
    return JSON.stringify(parsedData);
  },

  getCookiebyName: function (name) {
    var pair = document.cookie.match(new RegExp(name + '=([^;]+)'));
    return !!pair ? pair[1] : null;
  },

  /**
   * window.ACC.config.minicartRefresh is set in initialJavaScript.tag
   * based on minicartRefresh cookie set in the BE
   */
  getGtmCustomerDetails: function () {
    var globalStorage = localStorage.getItem('gtm.global');
    var refreshCustomerData = ACC.config.minicartRefresh || !globalStorage;
    if (refreshCustomerData && callCustomerData) {
      var gtmAjaxUrl = ACC.config.encodedContextPath + "/gtm/customerData";
      $.ajax({
        url: gtmAjaxUrl,
        contentType: "application/json",
        type: "GET",
        async: false,
        dataType: 'json',
        success: function (data) {
          if (data !== undefined) {
            var gtmStorage = JSON.parse(data);
            ACC.gtm.saveGtmCustomerDetails(gtmStorage);
          }
          ACC.gtm.resize = true;
          callCustomerData = false;
        }
      });
    }
    else {
      ACC.gtm.saveGtmCustomerDetails(JSON.parse(globalStorage));
    }
  },

  // getGtmCustomerDetails sets callCustomerData to false when called
  // this allows My Account to call getGtmCustomerDetails multiple times without having to refresh
  allowNextCustomerDataCall: function () {
    callCustomerData = true;
  },

  trackCheckoutStep: function (step, option, returnUrl, returnForm) {
    var options = {
      'event': 'checkout',
      'step': step,
      'option': option,
      'pageType': ACC.gtm.pageType,
      'pageName': ACC.gtm.pageName,
      'pageUrl': ACC.gtm.pageUrl
    };

    ACC.gtm.submitGtmEventData(options, returnUrl, returnForm);
  },

  attachProductClickHandler: function () {
    $(document).on('click', '.gtmProductClick', function (e) {
      e.preventDefault();

      var returnUrl = $(this).attr('href'),
        li = $(this).closest("li"),
        itemId = li.attr('id'),
        product = $(this).data('productcode');

      ACC.gtm.trackProductClickEvent(product, returnUrl);

      Cookies.set('itemTarget', itemId, { expires: 1 });
    });

    // stop propagation for href links until gtm is pushed
    $(document).on("click", ".gtmRecentlyViewedPrdClick, .gtmPrdCarouselClick", function (e) {
      e.preventDefault();
    });
  },

  trackGtmCommonEventData: function (product, returnUrl, returnForm, event) {
    var options = {
      'event': event,
      'pageType': ACC.gtm.pageType,
      'pageName': ACC.gtm.pageName,
      'pageUrl': ACC.gtm.pageUrl,
      'product': product
    };
    ACC.gtm.submitGtmEventData(options, returnUrl, returnForm);
  },

  trackGtmAddOrRemoveEventData: function (product, quantity, returnUrl, returnForm, event) {
    var options = {
      'event': event,
      'pageType': ACC.gtm.pageType,
      'pageName': ACC.gtm.pageName,
      'pageUrl': ACC.gtm.pageUrl,
      'product': product,
      'quantity': quantity
    };
    ACC.gtm.submitGtmEventData(options, returnUrl, returnForm);
  },

  trackWorldpayIframeGtmEventData: function () {
    var options = {
      'event': 'wpLoad',
      'pageType': ACC.gtm.pageType,
      'pageName': ACC.gtm.pageName,
      'pageUrl': ACC.gtm.pageUrl
    };
    ACC.gtm.submitGtmEventData(options, '', '');
  },

  bindPromotionClickEvents: function () {
    // bind the editorial grid view clicks for GTM
    $(".editorial-image-container, .editorial-title-container").on("click", function (e) {
      // stop propagation for href links until gtm is pushed
      var link = $(this).find("a");
      if (link.length > 0) {
        e.preventDefault();
      }

      var viewNumber = $(this).data("viewnumber");
      var componentId = $(this).data("componentid");

      if (typeof (viewNumber) != 'undefined') {
        ACC.gtm.trackPromotionClickGtmEvent(componentId, viewNumber);
      }

      if (link.length > 0) {
        var newWindow = link.attr("target") === "_blank";
        var url = link.attr("href");

        if (url) {
          window.open(url, newWindow ? "_blank" : "_self");
        }
      }
    });

    // bind the multiple grid component view clicks for GTM
    $(".multiple-content-image-link").on("click", function (e) {
      // stop propagation for href links until gtm is pushed
      var link = $(this).find("a");
      if (link.length > 0) {
        e.preventDefault();
      }

      var viewNumber = $(this).closest("li").data("viewnumber");
      var componentId = $(this).closest("li").data("componentid");

      if (typeof (viewNumber) != 'undefined') {
        ACC.gtm.trackPromotionClickGtmEvent(componentId, viewNumber);
      }

      if (link.length > 0) {
        var url = link.attr("href");
        if (typeof (url) != 'undefined') {
          window.location.href = url;
        }
      }
    });

    $(".content-grid-cta-link").on("click", function (e) {
      // stop propagation for href links until gtm is pushed
      var link = $(this).find("a");
      if (link.length > 0) {
        e.preventDefault();
      }

      var viewNumber = $(this).closest("li").data("viewnumber");
      var componentId = $(this).closest("li").data("componentid");

      if (typeof (viewNumber) != 'undefined') {
        ACC.gtm.trackPromotionClickGtmEvent(componentId, viewNumber);
      }

      if (link.length > 0) {
        var newWindow = link.attr("target") === "_blank";
        var url = link.attr("href");

        if (url) {
          window.open(url, newWindow ? "_blank" : "_self");
        }
      }
    });

    // bind the multiple grid component view clicks for GTM
    $(".teaser-wrapper .teaser-inner .media-container, .teaser-wrapper .teaser-inner .media-buttons-container li").on("click", function (e) {
      // stop propagation for href links until gtm is pushed
      var link = $(this).find("a");
      if (link.length > 0) {
        e.preventDefault();
      }

      var viewNumber = $(this).data("viewnumber");
      var componentId = $(this).data("componentid");

      if (typeof (viewNumber) != 'undefined') {
        ACC.gtm.trackPromotionClickGtmEvent(componentId, viewNumber);
      }

      if (link.length > 0) {
        var url = link.attr("href");
        if (typeof (url) != 'undefined') {
          window.location.href = url;
        }
      }
    });
  },

  scrollTopProduct: function () {
    if ($('body').hasClass('page-productGrid')) {
      var itemTarget = Cookies.get('itemTarget');

      if (itemTarget) {
        // check if the item is load in the page
        if ($('#' + itemTarget).is(':visible')) {
          var posItem = $('#' + itemTarget).offset().top;
          var finalPos = (posItem - 220);
          $('html, body').animate({ scrollTop: finalPos }, 300);
        }
      }
      Cookies.remove('itemTarget');
    }
  }
};

$(document).ready(function () {
  ACC.global.detectWindowResize('gtm');
  ACC.gtm.scrollTopProduct();
  /** Safari & Firefox BFCache (or Back-Forward Cache) on mobile devices according to ECOM-5085
  * causes a bounce back when navigating back (via the browser's Back button) to a PLP from a PDP.
  * This is due to the BFCache having the ability to freeze the state of the DOM as well as JavaScript
  * during execution. GTM's eventTimeout, in this case, is then effectively 'paused', and resumes execution
  * after the user has returned to the PLP from a PDP - in turn, bouncing the user back to the PDP.
  *
  * In order to prevent this we assign a boolean flag (pageFromBfCache) which will alternate to true if the current
  * page a user is on is rendered from the BFCache. The 'onpageshow' event listener uniquely listens for
  * pages which are loaded from the BFCache - we use this to change our 'pageFromBfCache' value to true. As a result,
  * we can then conditionally safeguard the assignment of our argument 'callbackUrl' to the 'window.location',
  * enabling us to then only pass valid 'productClicked' (our custom event) URL data to GTM.
  */
  $(window).on('pageshow', function (event) {
    /** The persisted property returns a Boolean value that indicates if the webpage is loaded directly from the server,
    //   * or if the page is cached, when an onpageshow or onpagehide event occurs.
    //   */
    if (event.originalEvent.persisted) {
      ACC.gtm.pageFromBfCache = true;
    }
  });
  /** In order to prevent the cache flag to remain set to true and prevent navigation to PDP pages when PLP is loaded
   * from BF cache we add a indow click event handler that will reset the flag to false on any window click
  */
  $(window).on('click', function () {
    if (ACC.gtm.pageFromBfCache) {
      ACC.gtm.pageFromBfCache = false;
    }
  });
  // Capture feedback ID when you submit Qubit Feedback form
  if (typeof uv !== 'undefined') {
    uv.on('qubit.feedback', function (data) {
      ACC.gtm.callWhenLoaded('trackQubitFeedbackId', data.feedback.id);
    });
  }
  // track successful registration to Treasure via MiniRegistration
  if ($(".checkout-guest-form-success").length > 0 && sessionStorage.getItem('miniRegistrationJoinedTreasure')) {
    ACC.gtm.callWhenLoaded('trackMiniRegistrationJoinTreasure', sessionStorage.getItem('miniRegistrationJoinedTreasure'));
    sessionStorage.removeItem('miniRegistrationJoinedTreasure');
  }
  // track successful registration to Treasure via full registration
  if (sessionStorage.getItem('registrationJoinedTreasure')) {
    ACC.gtm.callWhenLoaded('trackRegistrationJoinTreasure', sessionStorage.getItem('registrationJoinedTreasure'));
    sessionStorage.removeItem('registrationJoinedTreasure');
  }
});

/** getGtmCustomerDetails method depends on cookies, in case page is served from cache, the cookies are set only after ajax calls.**/
$(document).one("ajaxStop", function () {
  if ($(".checkout-header").length == 0) {
    ACC.gtm.getGtmCustomerDetails();
  }
});
